var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMc2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 51.18723,
    cy: 26.23896,
    fill: "#ffffff",
    id: "svg_1",
    r: 5.86712,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.25,
    cy: 74.375,
    fill: "#ffffff",
    id: "svg_2",
    r: 5.86712,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#000000",
    id: "svg_5",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 51.31001,
    x2: 51.31001,
    y1: 19.92392,
    y2: 7.70156
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#000000",
    id: "svg_6",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 51.18168,
    x2: 51.18168,
    y1: 90.25981,
    y2: 79.93745
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38,43.5a0.51,0.27 0 0 0 51,0",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_4",
    stroke: "#000000",
    strokeWidth: 2,
    transform: "rotate(-90 63.5 50.2477)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_3",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 70.14125,
    x2: 37.27762,
    y1: 49.41189,
    y2: 49.41189
  }), /*#__PURE__*/React.createElement("rect", {
    className: "status",
    fill: "#EF4444",
    height: 13.3268,
    id: "svg_9",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    width: 13.3268,
    x: 23.1875,
    y: 42.99627
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.35,4.85383c6.26665,-3.92425 6.07877,-3.62425 6.02574,-3.7034c-0.05303,-0.07915 0.07726,-0.12171 6.02423,3.59914",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_14",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.27502,12.06214c6.26665,-3.92425 6.07877,-3.62425 6.02574,-3.7034c-0.05303,-0.07915 0.07726,-0.12171 6.02423,3.59914",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_16",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.01251,98.88299c6.26665,-3.92425 6.07877,-3.62425 6.02574,-3.7034c-0.05303,-0.07915 0.07726,-0.12171 6.02423,3.59914",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_18",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    transform: "rotate(-180 51.0375 97.0208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.22502,91.23715c6.26665,-3.92425 6.07877,-3.62425 6.02574,-3.7034c-0.05303,-0.07915 0.07726,-0.12171 6.02423,3.59914",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_19",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    transform: "rotate(-180 51.25 89.375)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc2);
export default __webpack_public_path__ + "static/media/mc2.80ba2732.svg";
export { ForwardRef as ReactComponent };